import {} from './mutations';

export default {};
